// consts
import { CALENDAR_TYPE } from 'app/config/calendar_type.js';
import { FREQUENCY } from 'app/config/frequency_type.js';

function _convertToMinutesFrequency({ calendarType, frequencyAmount, frequencyTypeId }) {
  //
  const { EVERY, TIMES_PER, PER_SHIFT } = CALENDAR_TYPE;
  const { WEEK, BIWEEK, MONTH, DAY, MINUTE, HOUR } = FREQUENCY;

  if (!calendarType || !frequencyAmount || !frequencyTypeId) {
    return null;
  }

  if (calendarType === EVERY) {
    if (frequencyTypeId === HOUR) {
      return frequencyAmount * 60;
    }
    if (frequencyTypeId === MINUTE) {
      return frequencyAmount * 1;
    }
    if (frequencyTypeId === DAY) {
      return frequencyAmount * 24 * 60;
    }
    if (frequencyTypeId === WEEK) {
      return frequencyAmount * 7 * 24 * 60;
    }
    if (frequencyTypeId === BIWEEK) {
      return frequencyAmount * 14 * 24 * 60;
    }
    if (frequencyTypeId === MONTH) {
      return frequencyAmount * 30 * 24 * 60;
    }
  }

  if (calendarType === TIMES_PER) {
    // TODO desenvolver
    return null;
  }

  if (calendarType === PER_SHIFT) {
    return null;
  }

  return null;
}

export default _convertToMinutesFrequency;
